import genActTypes from '../core/types';

const types = genActTypes('media');

export default types;
